<div class="usan-form-item instructions-container">
  <div class="instructions-header">Instructions</div>
  <div class="instructions-text">
    <span class="text-line">Please complete all fields marked with *.</span>
    <span class="text-line">You can save your progress and return to the form as many times as you need before submitting.</span>
    <span class="text-line">Take your time to review all the information carefully, as once you submit the application,
    you won't be able to make any changes.</span> 
    <span class="text-line">If you're unsure about anything, don't hesitate to reach out for assistance.</span>
  </div>
</div>